import React, { Fragment } from 'react';
import { InputTextarea } from 'primereact/inputtextarea';
import PropTypes from 'prop-types';

const InputTextAreaPM = ({
  value = undefined,
  placeholder = null,
  onChange = null,
  rows = null,
  cols = null,
  maxLength = -1,
  autoResize = false,
  className = '',
  isFooter = false,
}) => {
  InputTextAreaPM.prototype = {
    value: PropTypes.string,
    placeholder: PropTypes.string,
    onChange: PropTypes.func,
    rows: PropTypes.number,
    cols: PropTypes.number,
    maxLength: PropTypes.number,
    autoResize: PropTypes.bool,
    className: PropTypes.string,
    isFooter: PropTypes.bool,
  };

  const onChangeTextArea = event => {
    let {
      target: { value },
    } = event;
    if (maxLength >= 0 && value.length > maxLength) {
      value = value.substring(0, maxLength);
    }

    if (onChange) {
      onChange(value);
    }
  };

  return (
    <Fragment>
      <div>
        <InputTextarea
          role="InputTextAreaPM"
          value={value || ''}
          placeholder={placeholder}
          className={`InputTextArea ${className}`}
          onChange={onChangeTextArea}
          rows={rows}
          cols={cols}
          autoResize={autoResize}
        />
        {isFooter && maxLength >= 0 && (
          <p className="text-area-footer">
            Characters: {value ? value.length : 0}/{maxLength}
          </p>
        )}
      </div>
    </Fragment>
  );
};

export default InputTextAreaPM;